import { useIsMobile } from "@shared/hooks/useIsMobile";
import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";

const TeacherCardSkeleton = () => {
  const isMobile = useIsMobile(640);
  return (
    <div className="rounded-8  relative border hover:border-fds-brand-light hover:shadow-brand-md active:border-fds-brand  border-fds-divider p-2  sm:p-3">
      <div className="relative ">
        <div className="w-full  sm:h-16 h-10 overflow-hidden rounded-4">
          <RectangularSkeleton width="100%" height="100%" />
        </div>
        <div className="absolute right-2  sm:right-3   sm:top-9 top-5 overflow-hidden rounded-full sm:w-14 sm:h-14 w-9 h-9">
          <RectangularSkeleton width="100%" height="100%" />
        </div>
      </div>

      <div className="mt-4     sm:mt-7">
        <RectangularSkeleton
          className="sm:mb-7 mb-2"
          width={"50%"}
          height={20}
        />
        <RectangularSkeleton
          width={"100%"}
          height={20}
          className=" sm:mb-6  mb-4"
        />
        <div className="mt-1">
          <div className="flex mb-1 items-center sm:body-xsm body-xxsm gap-1 sm:gap-1.5  text-fds-secondary  ">
            <RectangularSkeleton
              width={isMobile ? 16 : 20}
              height={isMobile ? 16 : 20}
            />
            <RectangularSkeleton width={40} height={isMobile ? 16 : 20} />
          </div>
          <div className="flex mt-1 items-center sm:body-xsm body-xxsm gap-1 sm:gap-1.5  text-fds-secondary  ">
            <RectangularSkeleton
              width={isMobile ? 16 : 20}
              height={isMobile ? 16 : 20}
            />
            <RectangularSkeleton width={60} height={isMobile ? 16 : 20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherCardSkeleton;
